module.exports = __webpack_public_path__ + "img/e_r_logo_dark.13585af2.png";